<template>
  <div class="new-contents">
    <ul class="nav-tab">
      <template v-if="isReceiveData">
        <li @click="contentType = 'layout'" :class="{selected: contentType === 'layout'}" class="layout">レイアウト</li>
        <li @click="contentType = 'design'" :class="{selected: contentType === 'design'}" class="design">デザインテンプレート</li>
        <li v-if="isCustomContents" @click="contentType = 'custom'" :class="{selected: contentType === 'custom'}" class="custom">オーダーメイド</li>
        <li @click="contentType = 'my'" :class="{selected: contentType === 'my'}" class="my">過去のメーリング</li>
        <li class="underline"></li>
      </template>
    </ul>
    <default-contents :isNew="true" :contentType="contentType" v-if="isShowDefault"/>
    <my-contents :isNew="true" :kind="'origin'" v-else/>
  </div>
</template>

<script>
import DefaultContents from '@/components/Contents/DefaultContents'
import MyContents from '@/components/Contents/MyContents'
export default {
  components: {
    DefaultContents,
    MyContents,
  },
  created () {
    this.getIsCustomContents()
  },
  data () {
    return {
      contentType: 'layout',
      isCustomContents: false,
      isReceiveData: false,
    }
  },
  computed: {
    isShowDefault () {
      return this.contentType === 'layout' || this.contentType === 'design' || this.contentType === 'custom'
    },
    isShowMy () {
      return this.contentType === 'my'
    }
  },
  methods: {
    getIsCustomContents () {
      this.$http({
        url: '/default_content/has_custom_content',
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.isCustomContents = json.data.hasCustomContent
          this.isReceiveData = true
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.new-contents {
  .nav-tab {
    li {
      &.layout {
        width: 160px;
        &::before {
          content: '\f0db';
        }
      }
      &.design {
        width: 250px;
        &::before {
          content: '\f53f';
        }
      }
      &.custom {
        width: 190px;
        &::before {
          content: '\f5ae';
        }
      }
      &.my {
        width: 210px;
        &::before {
          content: '\f0e0';
        }
      }
      &:nth-child(1).selected {
        ~ .underline {
          left: 0px;
          width: 160px;
        }
      }
      &:nth-child(2).selected {
        ~ .underline {
          left: 160px;
          width: 250px;
        }
      }
      &:nth-child(3).selected {
        ~ .underline {
          left: 410px;
          width: 210px;
        }
        &.custom {
          ~ .underline {
            width: 190px;
          }
        }
      }
      &:nth-child(4).selected {
        ~ .underline {
          left: 600px;
          width: 210px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.new-contents {
  font-size: 14px;
  position: relative;
  .nav-tab {
    position: relative;
    display: inline-block;
    margin-bottom: 60px;
    text-align: center;
    cursor: pointer;
    user-select:none;
    height: 40px;
    li {
      display: inline-block;
      color: #A7A7A7;
      background: #f8f8f8;
      height: 40px;
      line-height: 40px;
      border-bottom: #dbdbdb 0.5px solid;
      font-size: 18px;
      &:not(.underline) {
        &::before {
          font-family: "Font Awesome 5 Free";
          font-weight: 900;
          padding-right: 8px;
          font-size: 20px;
        }
        &.selected::before {
          color: $primaryColor;
        }
      }
      a {
        color: #A7A7A7;
        display: block;
      }
      &.selected, &:hover, a:hover {
        color: $commonFontColor;
      }
      &.selected {
        border: none;
        ~ .underline {
          height: 1.5px;
          background: $primaryColor;
          position: absolute;
          bottom: -1.5px;
          transition: all 0.2s ease-in-out 0s;
          border: none;
        }
      }
    }
  }
}
</style>
